module.exports = __webpack_public_path__ + "img/notification_on.e36a148d.svg";